<template>
    <div>
        <div :class="[
            {
                'hide-scroll': !showOverflowProductionProgress || modal.opened || showMultipleRefusesModal
            }
        ]" id="production-progress">
            <AppointmentHeader class="production-progress__page-header" :component-id="'appointment-screen'" :back-label="headerBackLabel"
                :back-event="headerBackEvent" :orders="headerOrders" :status="headerStatus" :color="headerColor"
                :isPointResourcePage="$router.currentRoute.name === 'operator-point-resource'"
                :resourceName="currentResource.resourceName" :orderObject="displayOrder"
                @removeAppointment="removeAppointmentFromMultiple" />

            <main class="content-container">
                <div v-if="$router.currentRoute.name === 'operator-point-resource'" class="point-resource-infos">
                    <div class="order-block">
                        <div class="label">{{ $t("orderView.Order") }}</div>
                        <div class="value">{{ order.orderNumber ? order.orderNumber : "-" }}</div>
                    </div>
                    <div :class="[
                        'material-block',
                        Number($route.params.current_order) <
                            Number($route.params.max_orders) &&
                            order.lastInfo.lastStatusId !== 1
                            ? ''
                            : '--remove-border-right'
                    ]">
                        <div class="label">Material</div>
                        <div class="value">{{ order.product ? order.product : "-" }}</div>
                    </div>
                    <div v-if="
                        order.lastInfo.lastStatusId !== 1 &&
                        Number($route.params.current_order) < Number($route.params.max_orders)
                    " class="add-resource" @click="handleNextResource">
                        <AddCircleIcon />
                    </div>
                </div>
                <div class="info-banner-wrapper"
                    v-if="['operator-point-resource', 'operator-production-progress', 'operator-production-progress-multiple'].includes($router.currentRoute.name)">
                    <InfoCard :infos="{
                        prod: displayResource.prodPercent,
                        perf: displayResource.perfPercent,
                        quality: displayResource.quality,
                        quantity: displayResource.totalQuantity,
                        prodQtd: displayResource.producedQuantity,
                        refuse: displayResource.refuse,
                        goodQtd: displayResource.goodQuantity,
                        rework: displayResource.reworkQuantity
                    }" @openOrderInfo="redirectToOrderDetails" @openLinks="handleOpenLinks()" @openAttachments="handleOpenLinks('attachments')" />
                </div>
                <div class="activity-cards">
                    <ActivityCard v-if="cards.setup.show" :title="$t('ProductionProgress.Setup')" type="setup"
                        :show-add-button="false" :active="cards.setup.active" :datetime="cards.setup.datetime"
                        :timer="timer.card === 'setup' ? timer.data : null"
                        @handleClick="openAppointmentModal('Setup')" />
                    <ActivityCard v-if="cards.startPartial.show" :title="timer.card === 'stop'
                        ? $t('ProductionProgress.Continue')
                        : $t('ProductionProgress.Start')
                        " :custom-active-label="$t('ProductionProgress.Partial')" type="start"
                        :show-add-button="handleShowAddButton()" :active="cards.startPartial.active"
                        :datetime="cards.startPartial.datetime" :timer="timer.card === 'start' ? timer.data : null"
                        @handleClick="
                            openAppointmentModal(
                                `${cards.startPartial.active ? 'Partial' : 'Start'}`
                            )
                            " />
                    <ActivityCard v-if="cards.stop.show" :title="$t('ProductionProgress.Stop')" type="stop"
                        show-add-button :active="cards.stop.active" :datetime="cards.stop.datetime"
                        :timer="timer.card === 'stop' ? timer.data : null"
                        @handleClick="openAppointmentModal('Stop')" />
                    <ActivityCard v-if="cards.finish.show" :title="cards.finish.active
                        ? $t('ProductionProgress.Finished')
                        : $t('ProductionProgress.Finish')
                        " type="finish" :show-add-button="false" :active="cards.finish.active"
                        :datetime="cards.finish.datetime"
                        @handleClick="cards.finish.active ? '' : openAppointmentModal('Finish')" />
                </div>

                <div v-if="
                    $router.currentRoute.name !== 'operator-point-resource' ||
                    defineStatus() !== 'not-started'
                " id="pdp__button-c">
                    <sys-button class="tools-button-desktop rnc-checklist-btn" scheme="float" variant="contained"
                        size="xl" :full="true" v-if="hasRNC" @click="handleOpenRNCChecklist">
                        <ChecklistIcon />
                        {{ $t("ProductionProgress.RNCChecklist") }}
                    </sys-button>
                    <sys-button class="tools-button-desktop" scheme="float" variant="outline" size="xl" :full="true"
                        @click="handleOpenManHourModal">
                        <OperatorIcon />
                        Apontar Hora Homem
                    </sys-button>

                    <sys-button class="tools-button-desktop" scheme="float" variant="outline" size="xl" :full="true"
                        @click="handleOpenRecordMaterialsModal" v-if="defineStatus() !== 'finished'">
                        <ToolsIcon />
                        {{ $t("ProductionProgress.RecordMaterials") }}
                    </sys-button>

                    <sys-button class="tools-button-desktop" scheme="float" variant="outline" size="xl" :full="true"
                        @click="handleOpenMaterialHistoryModal" v-if="defineStatus() === 'finished'">
                        <ToolsIcon />
                        {{ $t("ProductionProgress.HistoricalMaterials") }}
                    </sys-button>

                    <sys-dropdown class="buttons-mobile" scheme="slip" variant="contained" size="md"
                        @click="handleHistoryButton" full>
                        <TimeIcon />
                        {{ $t("ProductionProgress.History") }}

                        <template #droplist>
                            <b-dropdown-item @click="handleOpenRNCChecklist" v-if="hasRNC">
                                <ChecklistIcon />
                                {{ $t("ProductionProgress.RNCChecklist") }}
                            </b-dropdown-item>
                            <b-dropdown-item @click="handleOpenManHourModal">
                                <OperatorIcon />
                                Apontar Hora Homem
                            </b-dropdown-item>
                            <b-dropdown-item @click="handleOpenRecordMaterialsModal"
                                v-if="defineStatus() !== 'finished'">
                                <ToolsIcon />
                                {{ $t("ProductionProgress.RecordMaterials") }}
                            </b-dropdown-item>
                            <b-dropdown-item @click="openMaterialHistoryModal" v-if="defineStatus() === 'finished'">
                                <ToolsIcon />
                                {{ $t("ProductionProgress.HistoricalMaterials") }}
                            </b-dropdown-item>
                        </template>
                    </sys-dropdown>

                    <sys-button class="orders-details-button-desktop" scheme="float" variant="contained" size="xl"
                        :full="true" @click="handleHistoryButton">
                        <TimeIcon />
                        {{ $t("ProductionProgress.History") }}
                    </sys-button>
                </div>
            </main>
        </div>

        <AppointmentModal @removeAppointment="removeAppointmentFromMultiple" ref="appointmentModal"
            :allow-change-date="allowChangeDate"
            :order-object="displayOrder" :format-datetime="formatDatetime"
            :default-produced-quantity="remainingQuantity" :default-date="defaultDate" :default-resource="resource"
            :defaultMaterial="defaultMaterial" :defaultOrder="defaultOrder" :allow-change-resource="allowChangeResource"
            :resources-list="resourcesList" :status-list="statusList" :rejection-list="refuseStatus"
            :open.sync="modal.opened" :title="returnAppointmentModalTitle()" :show-toast="showToast"
            :isMultipleOrders="isMultipleOrders" :orderListDisplay="isMultipleOrders ? multipleOperationsList : listOfOrderNameAndOperation
                " :customFields="customFields" :exhibitionLocationId="this.modal.typeId" @close="closeAppointmentModal"
            @confirmAppointment="confirmAppointment" :appointmentType="appointmentType"
            :isPointResourcePage="$router.currentRoute.name === 'operator-point-resource'"
            :allowChangeMaterial="allowChangeMaterial" :allowChangeOrder="allowChangeOrder" :materialList="materialList"
            :orderList="orderList" @changeFields="updateFieldsList" :hasRNC="hasRNC" :checklistData="rncChecklistData"
            :checklistTriggerType="checklistTriggerType" :checklistTriggerTarget="checklistTriggerTarget"
            :shouldShowChecklist="shouldShowChecklist" @checklistCompleted="handleChecklistCompleted"
            :multiple-refuses="multipleRefuses" @openMultipleRefuses="handleOpenMultipleRefusesModal" @open="
                () => {
                    getMaterialList();
                    getOrderList();
                }
            " />

        <OrderDetailsModal v-if="showModalOrder" :open.sync="showModalOrder" :orderData="order"
            @close="onCloseDetailsModal" :showLinksProp="orderModalShowLinks" :showAttachmentsProp="orderListModalMode === 'attachments'" />

        <OrderDetailsListModal v-if="showModalOrderDetailsList" :open.sync="showModalOrderDetailsList"
            :mode="orderListModalMode" :statusList="statusList" :peopleList="peopleList" :shiftList="shiftList"
            @close="onCloseDetailsModal" :orderList="multiple.operations.map((order) => ({
                operationId: order.operationId,
                operationLabel: `${order.orderNumber}/${order.operationNumber}`
            }))
                " />

        <HistoryModal v-if="flags.showHistoryModal && !isMultipleOrders" :isFilter="true"
            :isFromOrders="$route.name !== 'operator-point-resource'" :operationId="order.id" :statusList="statusList"
            :peopleList="peopleList" :shiftList="shiftList" @close="onCloseHistoryModal" />

        <RecordMaterialsModal :open="flags.showRecordMaterialsModal" :orderId="order.id" @updated="handleOpenRecordMaterialsModal" />

        <OrdersGroupMaterialModal :open="flags.showOrdersGroupMaterialModal" />

        <BatchModal :open="flags.showBatchMaterialModal" :orderId="order.id" />

        <MaterialHistoryModal :open="flags.showMaterialHistoryModal" />

        <AddMaterialsModal :open="flags.showAddMaterialsModal" :orderId="order.id" />

        <OperationsModal :open="flags.showOperationsModal" />

        <ManHourModal :open.sync="showManHourModal" :peopleList="peopleList" :shiftList="shiftList"
            :usersList="usersList" :history="manHourHistory" @submit="handleManHourSubmit"
            @delete="deleteManHourAppointment" />

        <MultipleRefusesModal :open.sync="showMultipleRefusesModal" :rejection-list="refuseStatus" :order-object="order"
            :order-list-display="headerOrders" :header-status="headerStatus" :header-color="headerColor"
            :show-toast="showToast" :saved-entries="multipleRefuses" @save="saveMultipleRefuses"
            @close="showMultipleRefusesModal = false" />

        <transition name="appointment">
            <div v-if="showRNCChecklistForm" class="rnc-checklist-container">
                <ChecklistForm :checklist="rncChecklistData" :show-cancel-button="true"
                    :checklist-values-id="currentRNCChecklistValuesId" :submission-error="rncChecklistSubmissionError"
                    @submit="handleRNCChecklistSubmit" @finish="handleRNCChecklistClose"
                    @cancel="handleRNCChecklistClose" />
            </div>
        </transition>
    </div>
</template>

<script>
import { mapActions, mapGetters, mapMutations } from "vuex";

import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import AppointmentModal from "@/views/pages/operator/components/AppointmentModal/AppointmentModal.vue";
import moment from "moment";
import AppointmentHeader from "@/views/pages/operator/components/AppointmentHeader";
import ActivityCard from "./ActivityCard/index.vue";
import InfoCard from "./ActivityCard/Info.vue";
import Button from "./Button.vue";
import { BDropdown, BDropdownItem } from "bootstrap-vue";
import ToolsIcon from "@core/assets/formatted-icons/tools-icon.svg";
import SysButton from "@/@core/components/sys-button/index.vue";
import SysDropdown from "@/@core/components/sys-dropdown/index.vue";
import OrderDetailsIcon from "@/assets/images/icons/order-details-icon.svg";
import ShowDetailsIcon from "@core/assets/formatted-icons/show-details-icon.svg";
import AddCircleIcon from "@core/assets/icons/add-circle-md.svg";
import exhibitionLocationsEnum from "../enums/exhibitionLocationsIds.js";
import {
    formatCurrencyWithoutSymbol,
    handleConsumedRequired,
    handleFormatQuantityConsumedToNumber
} from "@/views/pages/operator/utils";
import {
    handleCreateParametersForPayload,
    handleFillCustomFields,
    processIndustrialParameters
} from "../utils/customfields";
import HistoryModal from "../components/HistoryModal/HistoryModal.vue";
import ChecklistForm from "@/views/pages/operator/components/ChecklistForm/ChecklistForm.vue";
import { http3 } from "@/libs/axios";
import jwtDefaultConfig from "@/@core/auth/jwt/jwtDefaultConfig";

export default {
    components: {
        ActivityCard,
        OrderDetailsIcon,
        ShowDetailsIcon,
        SysButton,
        SysDropdown,
        BDropdown,
        BDropdownItem,
        AppointmentHeader,
        Button,
        AppointmentModal,
        ToolsIcon,
        ToastificationContent,
        AddCircleIcon,
        InfoCard,
        HistoryModal,
        ChecklistForm,
        ChecklistIcon: () => import("@core/assets/icons/list.svg"),
        OperatorIcon: () => import("@core/assets/icons/operator.svg"),
        TimeIcon: () => import("@core/assets/icons/time-icon.svg"),
        OperationsModal: () =>
            import("@/views/pages/operator/components/OperationsModal/index.vue"),
        AddMaterialsModal: () =>
            import("@/views/pages/operator/components/AddMaterialsModal/index.vue"),
        MaterialHistoryModal: () =>
            import("@/views/pages/operator/components/MaterialHistoryModal/index.vue"),
        OrdersGroupMaterialModal: () =>
            import("@/views/pages/operator/components/OrdersGroupMaterialModal/index.vue"),
        BatchModal: () => import("@/views/pages/operator/components/BatchModal/index.vue"),
        RecordMaterialsModal: () =>
            import("@/views/pages/operator/components/RecordMaterialsModal/index.vue"),
        OrderDetailsModal: () =>
            import("@/views/pages/operator/components/OrderModal/OrderModal.vue"),
        OrderDetailsListModal: () =>
            import("@/views/pages/operator/components/OrderListModal/index.vue"),
        ManHourModal: () =>
            import("@/views/pages/operator/components/ManHourModal/index.vue"),
        MultipleRefusesModal: () =>
            import("@/views/pages/operator/components/MultipleRefusesModal/index.vue")
    },
    computed: {
        ...mapGetters("production_progress", ["flags"]),
        multipleTotals() {
            return (this.multiple.operations || []).reduce((totals, operation) => {
                for (const field of Object.keys(totals)) totals[field] += Number(operation[field] || 0);
                return totals;
            }, { plannedQuantity: 0, producedQuantity: 0, refuse: 0, rework: 0 });
        },
        displayOrder() {
            return this.isMultipleOrders ? { ...this.multiple, ...this.multipleTotals } : this.order;
        },
        displayResource() {
            if (!this.isMultipleOrders) return this.currentResource;
            const { plannedQuantity, producedQuantity, refuse, rework } = this.multipleTotals;
            const goodQuantity = producedQuantity - refuse - rework;
            return {
                totalQuantity: plannedQuantity,
                producedQuantity,
                refuse,
                reworkQuantity: rework,
                goodQuantity,
                prodPercent: plannedQuantity > 0 ? (producedQuantity / plannedQuantity * 100).toFixed(0) : "0",
                perfPercent: null,
                quality: producedQuantity > 0 ? (goodQuantity / producedQuantity * 100).toFixed(1) : "0.0"
            };
        },
        headerBackLabel() {
            return !this.appointmentType
                ? this.$t("ProductionProgress.ProductiveNote")
                : this.$t("ProductionProgress.ReworkNote");
        },
        headerOrders() {
            return this.isMultipleOrders
                ? this.multipleOperationsList
                : [
                    {
                        id: 0,
                        name: `${this.order.orderNumber}/${this.order.operationNumber}`
                    }
                ];
        },
        headerStatus() {
            return this.isMultipleOrders
                ? this.multiple?.lastInfo?.lastStatus
                : this.order?.lastInfo?.lastStatus;
        },
        headerColor() {
            if (this.isMultipleOrders) return this.multiple?.lastInfo?.lastColorStatus;
            return this.order?.lastInfo?.lastColorStatus;
        },
        appointmentType() {
            const type = this.$router.currentRoute.params.appointment_type;
            if (typeof type === "string") {
                return type === "true" || type === "1";
            }
            return !!type;
        },
        isMultipleOrdersByResource() {
            return (
                this.$router.currentRoute.name === "operator-production-progress-multiple" &&
                (this.$route.query.perOrderQuantity === "true" ||
                    this.$route.query.fromMultipleOrdersByResource === "true")
            );
        },
        moreThanOneCardShowing() {
            return (
                Object.keys(this?.cards).filter((card) => this?.cards?.[card]?.show)?.length > 1
            );
        },
        currentOperationProgressId() {
            return (this.order && this.order.lastInfo && this.order.lastInfo.lastOperationProgressId);
        }
    },
    methods: {
        ...mapMutations("app", ["UPDATE_FLAG_SHOW_OVERLAY"]),
        ...mapMutations("production_progress", [
            "UPDATE_FLAGS_IS_MULTIPLE_ORDERS",
            "UPDATE_RECORD_MATERIALS_MODAL_MATERIALS",
            "UPDATE_RECORD_MATERIALS_MODAL_FILTERED_MATERIALS_LIST",
            "UPDATE_RECORD_MATERIALS_MODAL_HISTORY",
            "UPDATE_MATERIAL_HISTORY_MODAL_HISTORY",
            "UPDATE_FLAGS_SHOW_HISTORY_MODAL",
            "UPDATE_RECORD_MATERIALS_MODAL_ORDER_GROUP_MATERIALS",
            "UPDATE_OPERATIONS_MODAL_OPERATIONS",
            "UPDATE_OPERATIONS_MODAL_FILTERED_OPERATIONS_LIST",
            "UPDATE_CURRENT_OPERATIONS_MODAL_OPERATIONS",
            "RESET_STATES"
        ]),
        ...mapActions("production_progress", [
            "openRecordMaterialsModal",
            "openMaterialHistoryModal"
        ]),
        ...mapActions("app", ["removeRequestLoading"]),
        handleOpenMultipleRefusesModal() {
            this.showMultipleRefusesModal = true;
        },
        saveMultipleRefuses(entries) {
            this.multipleRefuses = entries.map((entry) => ({ ...entry }));
            this.showMultipleRefusesModal = false;
        },
        async handleOpenManHourModal() {
            this.UPDATE_FLAG_SHOW_OVERLAY(true);
            try {
                await Promise.all([
                    this.getManHourHistory(),
                    this.getShifts(),
                    this.getUsers()
                ]);
                this.showManHourModal = true;
            } catch (error) {
                console.error("Error opening man hour modal:", error);
                this.showToast("Erro", "AlertCircleIcon", "Erro ao carregar dados.", "danger");
            } finally {
                this.UPDATE_FLAG_SHOW_OVERLAY(false);
            }
        },
        async getShifts() {
            try {
                const response = await this.$http2.get('/api/Shift', {
                    params: { siteId: this.currentSite },
                    headers: { Authorization: `${jwtDefaultConfig.tokenType} ${localStorage.getItem(jwtDefaultConfig.storageTokenKeyName)}` }
                });

                // Handle potential different response structures (wrapped in data or direct array)
                const shiftsData = response.data.data || response.data || [];

                this.shiftList = shiftsData.map(s => ({
                    ...s,
                    name: s.name || s.description || s.shiftName, // Fallback for name
                    value: s.id
                }));
            } catch (error) {
                console.error("Error fetching shifts:", error);
            }
        },
        async getUsers() {
            try {
                const response = await this.$http2.get('/api/myconfig/users', {
                    headers: { Authorization: `${jwtDefaultConfig.tokenType} ${localStorage.getItem(jwtDefaultConfig.storageTokenKeyName)}` }
                });
                this.usersList = response.data.data || [];

                const mappedUsers = this.usersList.map(u => ({
                    id: u.guid,
                    name: `${u.firstName} ${u.lastName}`.trim(),
                    value: u.guid
                }));

                // Remove duplicates by name
                const uniqueUsers = [];
                const names = new Set();

                mappedUsers.forEach(user => {
                    if (user.name && !names.has(user.name)) {
                        names.add(user.name);
                        uniqueUsers.push(user);
                    }
                });

                this.peopleList = uniqueUsers;
            } catch (error) {
                console.error("Error fetching users:", error);
            }
        },
        async handleManHourSubmit(formData) {
            const operatorGuids = formData.selectedPeople.map(p => p.value || p.id);
            const shiftId = formData.selectedShift?.value || formData.selectedShift?.id;
            const startTime = formData.startDate ? moment(formData.startDate).toISOString() : null;
            const endTime = formData.endDate ? moment(formData.endDate).toISOString() : null;

            const operationId = this.isMultipleOrders
                ? this.multiple?.operations?.[0]?.operationId
                : this.order?.id;

            if (!operatorGuids.length || !shiftId || !startTime || !endTime || !operationId) {
                this.showToast("Erro", "AlertCircleIcon", "Preencha todos os campos obrigatórios.", "danger");
                return;
            }

            const payload = {
                operatorGuids,
                shiftId,
                startTime,
                endTime,
                operationId,
                siteId: this.currentSite
            };

            await this.createManHourAppointment(payload);
        },
        async getManHourHistory() {
            try {
                const operationId = this.isMultipleOrders
                    ? this.multiple?.operations?.[0]?.operationId
                    : this.order?.id;

                if (!operationId) return;

                const response = await this.$http2.get(`/api/man-hour-appointment`, {
                    params: {
                        siteId: this.currentSite,
                        operationId: operationId
                    }
                });
                this.manHourHistory = response.data.data || [];
            } catch (error) {
                console.error("Error fetching man hour history:", error);
                this.showToast("Erro", "AlertCircleIcon", "Erro ao buscar histórico de horas homem.", "danger");
            }
        },

        async createManHourAppointment(payload) {
            try {
                this.UPDATE_FLAG_SHOW_OVERLAY(true);
                await this.$http2.post(`/api/man-hour-appointment`, payload);

                this.showToast(
                    this.$t("ProductionProgress.Success"),
                    "CheckIcon",
                    "Apontamento de hora homem realizado com sucesso.",
                    "success"
                );

                await this.getManHourHistory();
                this.showManHourModal = false;

            } catch (error) {
                console.error("Error creating man hour appointment:", error);
                const message = error.response?.data?.message || "Erro ao realizar apontamento.";
                this.showToast("Erro", "AlertCircleIcon", message, "danger");
            } finally {
                this.removeRequestLoading();
            }
        },

        async deleteManHourAppointment(id) {
            try {
                this.UPDATE_FLAG_SHOW_OVERLAY(true);
                await this.$http2.delete(`/api/man-hour-appointment`, {
                    params: { Id: id }
                });

                this.showToast(
                    this.$t("ProductionProgress.Success"),
                    "CheckIcon",
                    "Apontamento excluído com sucesso.",
                    "success"
                );

                await this.getManHourHistory();
            } catch (error) {
                console.error("Error deleting man hour appointment:", error);
                this.showToast("Erro", "AlertCircleIcon", "Erro ao excluir apontamento.", "danger");
            } finally {
                this.removeRequestLoading();
            }
        },
        async handleOpenMaterialHistoryModal() {
            this.UPDATE_FLAG_SHOW_OVERLAY(true);

            try {
                const response = await (this.isMultipleOrders
                    ? this.getMaterialsHistoryMultiple()
                    : this.getMaterialsHistory());

                this.UPDATE_MATERIAL_HISTORY_MODAL_HISTORY([...response]);
                this.openMaterialHistoryModal();
            } finally {
                this.UPDATE_FLAG_SHOW_OVERLAY(false);
            }
        },
        async getMaterialsMultiple() {
            const { preactor_orders } = this.$router.currentRoute.params;
            const GET_MATERIALS_URL = `/api/mysfc/operation/multiple/materials?operationIds=${preactor_orders}`;
            this.UPDATE_FLAG_SHOW_OVERLAY(true);

            try {
                const response = await this.$http2.get(GET_MATERIALS_URL);

                const formattedMaterials =
                    response?.data?.data.map((material) => {

                        const newMaterial = {
                            ...material,
                            totalConsumed: formatCurrencyWithoutSymbol(material.totalConsumed),
                            operations: material.materials.map((e) => {
                                const processedOperations = e.operations.map((op) => {
                                    let consumedValue = op.quantityConsumed;
                                    if (consumedValue === 0 || consumedValue === null || consumedValue === undefined) {
                                        consumedValue = op.quantityRequired;
                                    }

                                    return {
                                        ...op,
                                        quantityConsumed: formatCurrencyWithoutSymbol(consumedValue)
                                    };
                                });

                                return {
                                    ...e,
                                    operations: processedOperations,
                                    totalConsumed: formatCurrencyWithoutSymbol(e.totalConsumed),
                                    valid: null
                                };
                            })
                        };

                        newMaterial.totalConsumed = this.handleCalcTotalConsumed(newMaterial);

                        return newMaterial;
                    }) || [];

                return Promise.resolve(formattedMaterials);
            } catch (error) {
                console.error(error);
                return Promise.reject(error);
            }
        },
        handleCalcTotalConsumed(material) {
            const localMaterial = { ...material };

            const totalConsumed = localMaterial.operations.reduce((acc, operation) => {
                const quantityConsumed = handleFormatQuantityConsumedToNumber(
                    operation.quantityConsumed
                );

                return acc + quantityConsumed;
            }, 0);

            const formattedTotalConsumed = new Intl.NumberFormat("pt-BR", {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2
            }).format(totalConsumed);

            return formattedTotalConsumed;
        },
        async getMaterials() {
            const { order_id } = this.$router.currentRoute.params;
            const isPointResourcePage =
                this.$router.currentRoute.name === "operator-point-resource";
            const GET_MATERIALS_URL = `/api/mysfc/operation/${isPointResourcePage ? this.order.id : order_id}/materials`;

            try {
                const response = await this.$http2.get(GET_MATERIALS_URL);

                const formattedMaterials =
                    response?.data?.data?.map(batch => {
                        const materials = batch.materials.map(material => {
                            const alreadyConsumed = material.quantityConsumed == null ? 0 : material.quantityConsumed;
                            const remaining = Math.max(0, (material.quantityRequired || 0) - alreadyConsumed);
                            return {
                                ...material,
                                alreadyConsumed,
                                quantityConsumed: formatCurrencyWithoutSymbol(remaining)
                            };
                        });

                        return {
                            ...batch,
                            materials,
                            valid: null,
                            quantityConsumed: formatCurrencyWithoutSymbol(
                                handleConsumedRequired(
                                    batch.quantityRequired,
                                    batch.quantityConsumed,
                                    batch.required
                                )
                            )
                        };
                    }) || [];

                return Promise.resolve(formattedMaterials);
            } catch (error) {
                console.error(error);
                return Promise.reject(error);
            }
        },
        async getMaterialsHistory() {
            const { order_id } = this.$router.currentRoute.params;
            const GET_MATERIALS_HISTORY_URL = `/api/mysfc/operation/${order_id}/materials-history`;

            try {
                const response = await this.$http2.get(GET_MATERIALS_HISTORY_URL);

                const formattedMaterialsHistory = [];

                response?.data?.data?.forEach((material) => {
                    const { history, ...materialRest } = material;

                    material?.history?.forEach((history) => {
                        formattedMaterialsHistory.push({
                            ...materialRest,
                            ...history,
                            id: materialRest.id,
                            historyId: history.id ?? history.historyId
                        });
                    });
                });

                return Promise.resolve(formattedMaterialsHistory);
            } catch (error) {
                console.error(error);
                return Promise.reject(error);
            }
        },
        async getMaterialsHistoryMultiple() {
            const { preactor_orders } = this.$router.currentRoute.params;
            const GET_MATERIALS_HISTORY_MULTIPLE_URL = `/api/mysfc/operation/multiple/materials-history?operationIds=${preactor_orders ?? ""
                }`;

            try {
                const response = await this.$http2.get(GET_MATERIALS_HISTORY_MULTIPLE_URL);

                const formattedMaterialsHistory = [];

                response?.data?.data?.forEach((material) => {
                    const { history, ...materialRest } = material;
                    material?.history?.forEach((history) => {
                        formattedMaterialsHistory.push({
                            ...materialRest,
                            ...history,
                            id: materialRest.id,
                            historyId: history.id ?? history.historyId
                        });
                    });
                });

                return Promise.resolve(formattedMaterialsHistory);
            } catch (error) {
                console.error(error);
                return Promise.reject(error);
            }
        },
        async handleOpenRecordMaterialsModal() {
            this.UPDATE_FLAG_SHOW_OVERLAY(true);

            try {
                const [materialsHistoryResponse, materialsResponse] = await Promise.all([
                    this.isMultipleOrders
                        ? this.getMaterialsHistoryMultiple()
                        : this.getMaterialsHistory(),
                    this.isMultipleOrders ? this.getMaterialsMultiple() : this.getMaterials()
                ]);

                this.UPDATE_RECORD_MATERIALS_MODAL_MATERIALS([...materialsResponse]);
                this.UPDATE_RECORD_MATERIALS_MODAL_FILTERED_MATERIALS_LIST([
                    ...materialsResponse
                ]);

                this.UPDATE_RECORD_MATERIALS_MODAL_HISTORY([...materialsHistoryResponse]);
                this.openRecordMaterialsModal();
            } finally {
                this.UPDATE_FLAG_SHOW_OVERLAY(false);
            }
        },
        handleShowAddButton() {
            const isPointResourcePage =
                this.$router.currentRoute.name === "operator-point-resource";

            if (isPointResourcePage && this.resource?.appointmentType === 2) return false;

            return true;
        },
        async headerBackEvent() {
            const routeName = this.$router.currentRoute.name;
            const isPointResourcePage = routeName === "operator-point-resource";
            const isMultipleOrdersFlow = this.isMultipleOrdersByResource;
            const params = {
                prefix: localStorage.getItem("prefix")
            };

            if (isMultipleOrdersFlow) {
                const query = {};

                if (this.$route.query.groupId) {
                    query.groupId = this.$route.query.groupId;
                }

                if (this.$route.query.workcenterId) {
                    query.workcenterId = this.$route.query.workcenterId;
                }

                this.$router.push({
                    name: "operator-multiple-orders",
                    params,
                    query
                });
                return;
            }

            if (!isPointResourcePage) {
                this.$router.push({ name: "operator-orders-all", params });
            } else if (Number(this.$router.currentRoute.params.current_order) === 1) {
                const query = this.$route.query;

                if (query.fromFavorite) {
                    this.$router.push({
                        name: "operator-favorite-resources",
                        params
                    });
                } else {
                    const finalQuery = {};
                    if (query.groupId) finalQuery.groupId = query.groupId;
                    if (query.workcenterId) finalQuery.workcenterId = query.workcenterId;

                    this.$router.push({
                        name: "operator-resources",
                        params,
                        query: finalQuery
                    });
                }
            } else {
                const currentOrder = parseInt(this.$route.params.current_order);
                this.$router.replace({
                    name: "operator-point-resource",
                    params: {
                        ...this.$route.params,
                        current_order: currentOrder - 1
                    },
                    query: this.$route.query
                });
                await this.getResourceOrder(false);
                this.setCardsData();
            }
        },
        async handleNextResource() {
            const currentOrder = parseInt(this.$route.params.current_order);
            if (currentOrder < parseInt(this.$route.params.max_orders)) {
                this.$router.replace({
                    name: "operator-point-resource",
                    params: {
                        ...this.$route.params,
                        current_order: currentOrder + 1
                    },
                    query: this.$route.query
                });
            }
            await this.getResourceOrder(true, true);
            this.setCardsData();
        },
        onCloseHistoryModal() {
            this.UPDATE_FLAGS_SHOW_HISTORY_MODAL(false);
        },
        handleOpenLinks(mode = "links") {
            this.orderListModalMode = mode;
            if (this.isMultipleOrders) {
                this.showModalOrderDetailsList = true;
                this.showOverflowProductionProgress = false;
                return;
            }

            this.orderModalShowLinks = mode === "links";
            this.showModalOrder = true;
        },
        async onCloseDetailsModal() {
            this.showModalOrderDetailsList = false;
            this.showModalOrder = false;
            this.orderModalShowLinks = false;
            this.orderListModalMode = "details";
            this.showOverflowProductionProgress = true;

            const isPointResourcePage =
                this.$router.currentRoute.name === "operator-point-resource";

            if (this.isMultipleOrders) {
                this.UPDATE_FLAG_SHOW_OVERLAY(false);
                return;
            }

            this.UPDATE_FLAG_SHOW_OVERLAY(true);

            try {
                if (!isPointResourcePage) {
                    await this.getOrder(true, this.appointmentType);
                } else {
                    await this.getResourceOrder();
                }

                this.setCardsData();
            } catch {
                if (!isPointResourcePage) {
                    this.$router.push({
                        name: "operator-orders-all",
                        params: { prefix: localStorage.getItem("prefix") }
                    });
                }
            } finally {
                this.UPDATE_FLAG_SHOW_OVERLAY(false);
            }
        },
        async removeAppointmentFromMultiple(appointmentId) {
            const { preactorsOrdersId } = this;
            const orders = preactorsOrdersId.split(",");
            const params = this.$route.params;
            const updatedOrders = orders.filter(
                (order) => Number(order) !== Number(appointmentId)
            );
            const updatedParams = {
                ...params,
                preactor_orders: updatedOrders.join(",")
            };

            if (updatedOrders.length === 1) {
                // Se tiver somente 1 ordem, redirecionar para apontamento individual
                const resourceId = this.multiple?.resource[0].id;
                const is_rework = this.appointmentType;
                const orderParams = {
                    prefix: params.prefix,
                    return_orders: "true",
                    multiple: "false",
                    order_id: String(updatedOrders[0]),
                    resource_id: resourceId,
                    orders: [],
                    appointment_type: Number(is_rework)
                };

                this.$router
                    .push({
                        name: "operator-production-progress",
                        params: orderParams
                    })
                    .then(() => {
                        this.$router.go();
                    });

                return;
            }

            this.$router.replace({
                params: updatedParams,
                query: this.$route.query
            });

            await this.loadPage(this.appointmentType);
        },
        returnAppointmentModalTitle() {
            const { modal, cards } = this;

            if ((modal.type === "Partial" || modal.type === "Start") && cards.stop.active) {
                this.modal.typeId = exhibitionLocationsEnum.Continue;
                return "Continue";
            }

            return modal.type;
        },
        async openAppointmentModal(type) {
            if ((this.isMultipleOrdersByResource || (this.isMultipleOrders && !this.appointmentType)) && type === "Partial") {
                this.$router.push({
                    name: "operator-multiple-orders-quantity",
                    params: {
                        prefix: localStorage.getItem("prefix") || this.$route.params.prefix,
                        resource_id: this.resource?.value || this.$route.params.resource_id,
                        preactor_orders: this.$route.params.preactor_orders
                    },
                    query: this.$route.query
                });
                return;
            }

            await this.getContext(false);
            this.createListOfOrderNameAndOperation();
            switch (type) {
                case "Setup":
                    this.modal.typeId = exhibitionLocationsEnum.Setup;

                    break;
                case "Start":
                    this.modal.typeId = exhibitionLocationsEnum.Start;

                    break;
                case "Partial":
                    this.modal.typeId = exhibitionLocationsEnum.Partial;

                    break;

                case "Stop":
                    this.modal.typeId = exhibitionLocationsEnum.Stop;

                    break;
                case "Continue":
                    this.modal.typeId = exhibitionLocationsEnum.Continue;

                    break;
                case "Finish":
                    this.modal.typeId = exhibitionLocationsEnum.Finish;

                    break;

                default:
                    this.modal.typeId = null;
                    break;
            }
            this.multipleRefuses = [];
            this.modal.type = type;
            this.modal.opened = true;
        },
        closeAppointmentModal() {
            this.showMultipleRefusesModal = false;
            this.multipleRefuses = [];
            this.modal.opened = false;

            this.$nextTick(() => {
                this.modal.type = "";
                this.modal.typeId = null;
            });
        },
        getSelectedStatusId(data) {
            const findStatusId = (term) =>
                this.statusList.filter((item) => item.text === term)[0].value;
            const modal = this.modal.type.toLowerCase();

            const currentStatus = (() => {
                if (modal === "stop") return data.status.id;

                if (modal === "start" || modal === "partial" || modal === "continue") {
                    const noActiveCard = !Object.keys(this.cards).some(
                        (item) => this.cards[item].active
                    );

                    if (this.cards.setup.active || noActiveCard)
                        return findStatusId("Iniciado");

                    return findStatusId("Executando");
                }

                if (modal === "setup") return findStatusId("Setup");
                if (modal === "finish") return findStatusId("Operação Finalizada");
            })();

            return currentStatus;
        },
        async confirmAppointment(data) {

            const event_time = data.datepicker;

            const statusId = this.getSelectedStatusId(data);
            const is_rework = this.appointmentType;
            const modal = this.modal.type.toLowerCase();

            const resourceId = data.resource.id
                ? data.resource.id
                : this.$router.currentRoute.params.resource_id;

            if (data.resource && data.resource.id) {
                this.resource = {
                    appointmentType: 1,
                    value: Number(data.resource.id),
                    text: data.resource.value
                };
            }

            const showModal = this.isMultipleOrders
                ? !is_rework && this.multiple.operations.some(op => Number(op.producedQuantity || 0) < Number(op.plannedQuantity || 0))
                : this.order.producedQuantity < this.order.plannedQuantity;

            const executeActions = async (producedQuantity = data?.produced?.value || null, completePlannedQuantity = false) => {
                const result = await this.createNewAppointment(
                    statusId,
                    event_time,
                    producedQuantity,
                    data.rejection.value ? data.rejection.value : 0,
                    data.rework.value ? data.rework.value : 0,
                    data.reason.id ? data.reason.id : 0,
                    resourceId,
                    is_rework,
                    data.order ? data.order : null,
                    this.multipleRefuses,
                    completePlannedQuantity
                );

                if (result === false) {
                    await this.loadPage(is_rework);
                    return;
                }
                const hasChecklist = await this.checkChecklistAfterAppointment();
                if (hasChecklist) {
                    if (this.$router.currentRoute.name !== "operator-point-resource") {
                        await this.getOrder(false, is_rework);
                    } else {
                        await this.getResourceOrder(false, false, data.order ? data.order.id : null, is_rework);
                    }
                    this.setCardsData();
                } else {
                    await this.loadPage(modal == "finish" ? false : is_rework, data.order);
                }
            };

            if (modal === "finish" && showModal) {
                this.$swal({
                    title: this.$t("IntegrationPage.attention"),
                    html: this.isMultipleOrders ? this.$t("ProductionProgress.MultipleBelowPlanned") : `
                            <div class="text-left">
                                <div>
                                ${this.$t("ProductionProgress.FirstDeleteMessage")} <b>${this.order.producedQuantity}</b> 
                                ${this.$t("ProductionProgress.from")} <b>${this.order.plannedQuantity}</b>. ${this.$t("ProductionProgress.LastDeleteMessage")}
                                </div>
                            </div>
                        `,
                    showCancelButton: true,
                    showCloseButton: true,
                    showDenyButton: true,
                    cancelButtonText: this.$t("No"),
                    denyButtonText: this.$t("ProductionProgress.FinishWithPlannedQuantity"),
                    confirmButtonText: this.$t("Yes"),
                    customClass: {
                        container: "swal-default finish-quantity-swal",
                        confirmButton: "btn btn-primary",
                        denyButton: "btn btn-outline-danger ml-1",
                        cancelButton: "btn btn-outline-danger ml-1"
                    },
                    buttonsStyling: false
                }).then(async (result) => {
                    if (result.value) {
                        const operations = this.isMultipleOrders ? this.multiple.operations : [this.order];
                        if (!is_rework && operations.some(op => op.blockFinishBelowPlanned && Number(op.producedQuantity || 0) + Number(data?.produced?.value || 0) < Number(op.plannedQuantity || 0))) {
                            this.$toast({ component: ToastificationContent, props: {
                                title: this.$t("ProductionProgress.FinishBelowPlannedBlocked"),
                                icon: "AlertTriangleIcon", variant: "warning"
                            } });
                            return;
                        }
                        await executeActions();
                        if (!this.$refs.appointmentModal?.showChecklistForm) {
                            this.closeAppointmentModal();
                        }
                    } else if (result.isDenied) {
                        await executeActions(this.isMultipleOrders ? null : this.order.plannedQuantity - this.order.producedQuantity, this.isMultipleOrders);
                        if (!this.$refs.appointmentModal?.showChecklistForm) {
                            this.closeAppointmentModal();
                        }
                    }
                });
            } else {
                await executeActions();
                if (!this.$refs.appointmentModal?.showChecklistForm) {
                    this.closeAppointmentModal();
                }
            }
        },
        adjustTimeZone3(inputDate) {
            let date = inputDate;

            if (!(inputDate instanceof Date)) {
                date = new Date(inputDate);
            }

            const offset = date.getTimezoneOffset() * 60000;
            const localISOTime = new Date(date.getTime() - offset).toISOString().slice(0, -1);
            return localISOTime;
        },
        redirectToOrderDetails() {
            if (this.isMultipleOrders) {
                this.orderListModalMode = "details";
                this.showModalOrderDetailsList = true;
            } else {
                this.showModalOrder = true;
            }
            this.showOverflowProductionProgress = false;
        },
        handleHistoryButton() {
            if (this.isMultipleOrders) {
                this.orderListModalMode = "history";
                this.showModalOrderDetailsList = true;
                this.showOverflowProductionProgress = false;
                return;
            }

            this.UPDATE_FLAGS_SHOW_HISTORY_MODAL(true);
        },
        formatDatetime(date) {
            if (!date) return null;

            const language = String(this.$i18n.locale);
            const PT_FORMAT = "DD-MM-YYYY HH:mm:ss";
            const EN_FORMAT = "MM-DD-YYYY HH:mm:ss";

            if (date instanceof Date || moment.isMoment(date) || moment(date).isValid()) {
                // Se for objeto Date do JS ou for objeto Moment
                if (language == "pt-BR") {
                    return moment(date).format(PT_FORMAT);
                }

                return moment(date).format(EN_FORMAT);
            }
            // Se for formatado da própria aplicação (mudança de idioma)
            if (language === "pt-BR") {
                return moment(date, EN_FORMAT).format(PT_FORMAT);
            }
            return moment(date, PT_FORMAT).format(EN_FORMAT);
        },
        resetTimer() {
            clearInterval(this.timer.interval);
            this.timer.startingTime = null;
            this.timer.elapsedTime = null;
        },
        formatTimer(str) {
            return str.toString().padStart(2, "0");
        },
        createTimer(startingTime = 0) {
            const alreadyHasTimerRunning = !!this?.timer?.interval;

            if (alreadyHasTimerRunning) this.resetTimer();

            this.timer.startingTime = moment(startingTime);
            this.timer.elapsedTime = moment().valueOf() - this.timer.startingTime.valueOf();

            this.timer.interval = setInterval(() => {
                this.timer.elapsedTime += 1000;

                const { elapsedTime } = this.timer;
                const second = this.formatTimer(Math.floor(elapsedTime / 1000) % 60);
                const minute = this.formatTimer(Math.floor(elapsedTime / 1000 / 60) % 60);
                const hour = this.formatTimer(Math.floor(elapsedTime / 1000 / 60 / 60));

                this.timer.data = {
                    hour,
                    minute,
                    second
                };
            }, 1000);
        },
        defineStatus() {
            const orderInfo = this.isMultipleOrders ? this.multiple : this.order;
            // Definindo os dados dos cards
            const status = orderInfo?.lastInfo?.lastStatus;

            switch (status) {
                case "Iniciado":
                case "Started":
                    return "started";
                case "Não Iniciado":
                    return "not-started";
                case "Setup":
                    return "setup";
                case "Executando":
                case "Running":
                    return "running";
                case "Completed":
                case "Operação Finalizada":
                    return "finished";
                default:
                    return "stopped";
            }
        },
        setCardsTimestamps(lastActivities) {
            this.cards.setup.datetime = this.formatDatetime(lastActivities.setup);
            this.cards.startPartial.datetime = lastActivities.running
                ? this.formatDatetime(lastActivities.running)
                : this.formatDatetime(lastActivities.start);
            this.cards.stop.datetime = this.formatDatetime(lastActivities.stop);
            this.cards.finish.datetime = this.formatDatetime(lastActivities.finished);
        },
        setFormDefaultValues() {
            const orderInfo = this.isMultipleOrders ? this.multiple : this.order;

            // Definindo valores padrão para datepicker da modal (Setup e Start)
            this.defaultDate.setup =
                orderInfo.setup_start && moment(orderInfo.setup_start).isBefore(new Date())
                    ? moment(orderInfo.setup_start).toDate()
                    : new Date();

            this.defaultDate.start =
                orderInfo.start_time && moment(orderInfo.start_time).isBefore(new Date())
                    ? moment(orderInfo.start_time).toDate()
                    : new Date();
        },

        setCardsData() {
            // Definindo apontamento individual / em massa
            const orderInfo = this.isMultipleOrders ? this.multiple : this.order;

            // Definindo os dados dos cards
            const status = this.defineStatus();

            let startingTime = null;
            let cardsToShow = ["setup", "start", "stop"];

            const lastActivities = {
                start: orderInfo.lastInfo.lastStarted,
                running: orderInfo.lastInfo.lastRunning,
                finished: orderInfo.lastInfo.lastCompleted,
                setup: orderInfo.lastInfo.lastSetup,
                stop: orderInfo.lastInfo.lastStopped
            };

            this.lastActivities = lastActivities;

            const active = (() => {
                if (status === "not-started") return false;

                if (status === "started") {
                    startingTime = lastActivities.start;
                    return "start";
                }

                if (status === "running") {
                    startingTime = lastActivities.running;
                    return "start";
                }

                if (status === "finished") {
                    startingTime = lastActivities.finished;
                    cardsToShow = ["finish"];
                    return "finish";
                }

                if (status === "setup") {
                    startingTime = lastActivities.setup;
                    return "setup";
                }

                startingTime = lastActivities.stop;
                return "stop";
            })();

            startingTime && this.createTimer(startingTime);
            this.timer.card = active;

            // Card Finalizar só aparece caso esteja executando ou finalizado
            const showCard = (card) =>
                card === "finish"
                    ? ["finish", "start"].includes(active)
                    : cardsToShow.includes(card);

            // Definindo regras e valores dos cards
            this.cards = {
                setup: {
                    show: showCard("setup"),
                    active: active === "setup"
                },
                startPartial: {
                    show: showCard("start"),
                    active: active === "start"
                },
                stop: {
                    show: showCard("stop"),
                    active: active === "stop"
                },
                finish: {
                    show: showCard("finish"),
                    active: active === "finish"
                }
            };

            // Definindo horários de último apontamento e valores padrão de formulários
            this.setCardsTimestamps(lastActivities);
            this.setFormDefaultValues();
        },
        async createNewAppointment(
            status,
            event_time,
            produced_quantity,
            refuse,
            rework,
            rejection_reason_id,
            resource_id,
            is_rework,
            order = null,
            multipleRefuses = [],
            completePlannedQuantity = false
        ) {
            const customFields = this.customFields.filter((e) =>
                e.exhibitionLocationIds.includes(this.modal.typeId)
            );
            const parameters = handleCreateParametersForPayload(customFields);
            if (this.idsNotFound) {
                for (const value of this.idsNotFound) {
                    let ids = this.preactorsOrdersId.split(",");
                    let index = ids.indexOf(value);
                    while (index !== -1) {
                        ids.splice(index, 1);
                        index = ids.indexOf(value, index);
                    }
                    this.preactorsOrdersId = ids.join(",");
                }
            }

            const operationsIds = this.multiple?.operations?.map((e) => e.operationId) || [];

            const operationId = order.operationId
                ? order.operationId
                : this.isMultipleOrders
                    ? operationsIds
                    : this.order.id;

            const body = {
                operationId: operationId,
                userGuid: this.$cookies.get("userInfo").userData.guid,
                statusId: status,
                producedQuantity: this.formatedNumber(produced_quantity),
                refuse: this.formatedNumber(refuse),
                rework: this.formatedNumber(rework),
                resourceId: resource_id,
                eventTime: this.adjustTimeZone3(event_time),
                refuseReasonId: rejection_reason_id !== 0 ? rejection_reason_id : null,
                isRework: !!is_rework,
                industrialParameter: parameters,
                ...(completePlannedQuantity ? { completePlannedQuantity: true } : {})
            };

            const appointmentBody = multipleRefuses.length
                ? multipleRefuses.map((entry, index) => ({
                    ...body,
                    producedQuantity: index === 0 ? body.producedQuantity : null,
                    refuse: this.formatedNumber(entry.quantity),
                    rework: index === 0 ? body.rework : 0,
                    refuseReasonId: entry.reasonId,
                    industrialParameter: index === 0 ? body.industrialParameter : []
                }))
                : body;

            return await (this.isMultipleOrders
                ? this.createMultipleAppointment(appointmentBody)
                : this.createSingleAppointment(appointmentBody, order));
        },
        formatedNumber(value) {
            if (typeof value !== "string") return value;
            const cleaned = value.replace(/\./g, "").replace(",", ".");
            return parseFloat(cleaned);
        },
        async createSingleAppointment(body, order = null) {
            const POST_CREATE_SINGLE_APPOINTMENT_URL = `/api/mysfc/operator/operation-progress?siteId=${this.currentSite}`;

            try {
                this.UPDATE_FLAG_SHOW_OVERLAY(true);
                const appointments = Array.isArray(body) ? body : [body];

                for (const appointment of appointments) {
                    await this.$http2.post(POST_CREATE_SINGLE_APPOINTMENT_URL, appointment);
                }

                if (this.isMultipleOrders) {
                    this.showToast(
                        this.$t("ProductionProgress.Success"),
                        "FrownIcon",
                        this.$t("ProductionProgress.OperationProgressRegistred"),
                        "success"
                    );
                    return;
                }

                this.showToast(
                    this.$t("ProductionProgress.Toasts.Success.Title"),
                    "FrownIcon",
                    this.$t("ProductionProgress.Toasts.Success.Content"),
                    "success"
                );
            } catch (error) {
                error.response.data.errors.map((e) => {
                    let message =
                        e.id == 196
                            ? this.$t("MandatoryMaterialsError")
                            : this.$t(e.message ?? "");
                    this.showToast(this.$t("Error"), "FrownIcon", message, "danger");
                });
            } finally {
                this.removeRequestLoading();
            }
        },
        async createMultipleAppointment(body) {
            const POST_CREATE_MULTIPLE_APPOINTMENT_URL = `/api/mysfc/operator/multiple/operation-progress?siteId=${this.currentSite}`;

            try {
                this.UPDATE_FLAG_SHOW_OVERLAY(true);
                const response = await this.$http2.post(POST_CREATE_MULTIPLE_APPOINTMENT_URL, body);
                const failed = response.data?.data?.result?.failed || [];
                if (failed.length) {
                    const details = failed.map(failure => {
                        const operation = this.multiple.operations.find(op => op.operationId === failure.operationId);
                        return `${operation ? `${operation.orderNumber}/${operation.operationNumber}` : failure.operationId}: ${failure.message}`;
                    }).join("; ");
                    this.showToast(this.$t("Error"), "FrownIcon", details, "danger");
                    return false;
                }

                if (this.isMultipleOrders) {
                    this.showToast(
                        this.$t("ProductionProgress.Success"),
                        "FrownIcon",
                        this.$t("ProductionProgress.OperationProgressRegistred"),
                        "success"
                    );
                    return;
                }

                this.showToast(
                    this.$t("ProductionProgress.Success"),
                    "FrownIcon",
                    `${this.$t("ProductionProgress.OperationProgressRegistred")}: ${this.$t(
                        "ProductionProgress.Order"
                    )} ${this.order.orderNumber}`,
                    "success"
                );
            } catch (error) {
                this.sendingForm = false;
                this.idsNotFound = error.response.data.idsNotFound;
                let toastText = "";
                if (this.idsNotFound) {
                    const orderNotFound = this.idsNotFound.map((id) => {
                        return this.multiple.orders.find(
                            (order) => order.preactor_order_id === id
                        );
                    });
                    const getOrderNamesById = orderNotFound
                        .map((order) => `${order.orderNumber}/${order.operationNumber}`)
                        .join(", ");
                    if (orderNotFound.length > 1) {
                        toastText = `${this.$t(
                            "ProductionProgress.Toasts.OrderNotFoundPlural1"
                        )} ${getOrderNamesById}${this.$t(
                            "ProductionProgress.Toasts.OrderNotFoundPlural2"
                        )}`;
                    } else if (orderNotFound.length === 1) {
                        toastText = `${this.$t(
                            "ProductionProgress.Toasts.OrderNotFoundSingular1"
                        )} ${getOrderNamesById} ${this.$t(
                            "ProductionProgress.Toasts.OrderNotFoundSingular2"
                        )}`;
                    }
                } else {
                    toastText = this.$t(error.response.data.errors?.[0]?.message ?? error.response.data.message ?? "");
                }

                this.showToast(this.$t("Error"), "FrownIcon", toastText, "danger");
                return false;
            } finally {
                this.removeRequestLoading();
            }
        },
        async getContext(useLoading = true) {
            const GET_CONTEXT_URL = `/api/mysfc/operation-progress/context?siteId=${this.currentSite}&workcenterId=${this.$route.query.workcenterId || ""}&operationId=${!this.isMultipleOrders ? this.order?.id || "" : ""}&resourceId=${this.resource?.value || this.$route.params.resource_id || ""}`;

            try {
                useLoading && this.UPDATE_FLAG_SHOW_OVERLAY(true);
                const response = await this.$http2.get(GET_CONTEXT_URL);
                const data = response.data.data;

                this.statusList =
                    data.status?.map((e) => ({
                        ...e,
                        text: e.name,
                        value: e.id
                    })) ?? [];
                this.shiftList =
                    data.shifts?.map((e) => ({
                        ...e,
                        value: e.id
                    })) ?? [];
                this.peopleList =
                    data.person?.map((e) => ({
                        id: e.userGuid,
                        name: e.fullName,
                        value: e.userGuid
                    })) ?? [];
                this.refuseStatus =
                    data.refuseReasons?.filter(r => !this.isMultipleOrders || !r.workcenterIds?.length || this.multiple.operations.every(op => r.workcenterIds.includes(op.workcenterId))).map((e) => ({
                        ...e,
                        text: e.name,
                        value: e.id
                    })) ?? [];
                this.customFields = processIndustrialParameters(data.industrialParameters);
                handleFillCustomFields(this.customFields);

                return Promise.resolve(response);
            } catch (error) {
                console.error(error);

                return Promise.reject(error);
            } finally {
                useLoading && this.UPDATE_FLAG_SHOW_OVERLAY(false);
            }
        },
        async getResourcesList(useLoading = true) {
            this.resourcesList = [];
            const operationId = this.isMultipleOrders ? this.multiple.operations[0]?.operationId : this.$router.currentRoute.params.order_id;
            const GET_RESOURCES_URL = `/api/mysfc/resource/workcenters?siteId=${this.currentSite}&operationId=${operationId}`;
            try {
                useLoading && this.UPDATE_FLAG_SHOW_OVERLAY(true);
                const response = await this.$http2.get(GET_RESOURCES_URL);

                const data = response?.data ?? [];

                const resources = data
                    ?.map((resource) => ({
                        text: resource.name,
                        value: resource.id,
                        allow_change_resource: resource.allowResourceChange,
                        allow_change_date: resource.allowChangeDate
                    }));

                this.resourcesList = resources;

                const targetResId = this.resource?.value || this.$router.currentRoute.params.resource_id;
                const targetRes = data.find((element) => element.id == targetResId);

                if (this.isMultipleOrdersByResource) {
                    this.allowChangeResource = false;
                    if (targetRes) {
                        this.resource = {
                            appointmentType: targetRes.appointmentType ?? 1,
                            value: targetRes.id,
                            text: targetRes.name
                        };
                        this.currentResource = {
                            ...this.currentResource,
                            resourceName: targetRes.name,
                            resourceId: targetRes.id
                        };
                    }
                } else {
                    const isOPInProgress = this.defineStatus() !== "not-started";
                    if (isOPInProgress) {
                        this.allowChangeResource = targetRes ? !!targetRes.allowResourceChangeInProgress : false;
                    } else {
                        this.allowChangeResource = targetRes ? !!targetRes.allowResourceChange : false;
                    }
                }

                this.allowChangeDate = targetRes ? !!targetRes.allowChangeDate : false;

                return Promise.resolve(response);
            } catch (error) {
                console.error(error);

                return Promise.reject(response);
            } finally {
                useLoading && this.removeRequestLoading();
            }
        },
        async getOrders(useLoading = true, is_rework = false) {
            let ids = [];

            if (this.$router.currentRoute.params.orders) {
                ids = this.$router.currentRoute.params.orders
                    .map((order) => order.operation?.id ?? order.operationId)
                    .filter((id) => id !== null && id !== undefined);
            } else {
                ids = this.$router.currentRoute.params.preactor_orders.split(",");
            }

            let GET_ORDERS_URL = `api/mysfc/operator/multiple/operations?Ids=${ids}&SiteId=${this.currentSite}&isRework=${is_rework}`;

            try {
                useLoading && this.UPDATE_FLAG_SHOW_OVERLAY(true);
                const response = await this.$http2.get(GET_ORDERS_URL);
                const data = response.data.data;

                const sum = (field) => data.operations.reduce((total, op) => total + Number(op[field] || 0), 0);
                this.plannedQuantity = sum("plannedQuantity");
                this.producedQuantity = sum("producedQuantity");
                this.order = { plannedQuantity: this.plannedQuantity, producedQuantity: this.producedQuantity };
                this.multiple = { ...data, ...this.order };
                const goodQuantity = this.producedQuantity - sum("refuse") - sum("rework");
                this.currentResource = {
                    ...this.currentResource,
                    totalQuantity: this.plannedQuantity,
                    producedQuantity: this.producedQuantity,
                    refuse: sum("refuse"),
                    reworkQuantity: sum("rework"),
                    goodQuantity,
                    prodPercent: this.plannedQuantity ? (this.producedQuantity / this.plannedQuantity * 100).toFixed(0) : "0",
                    quality: this.producedQuantity ? (goodQuantity / this.producedQuantity * 100).toFixed(1) : "0.0"
                };

                const uniqueResources = [];
                const seenIds = new Set();
                data.resource?.forEach(r => {
                    if (r && r.id && !seenIds.has(r.id)) {
                        seenIds.add(r.id);
                        uniqueResources.push(r);
                    }
                });

                const selectedResourceId = data.lastInfo?.lastResource?.id || this.resource?.value;
                const hasAppointments = !!(
                    data.lastInfo &&
                    (
                        (data.lastInfo.lastStatusId && data.lastInfo.lastStatusId !== 1) ||
                        data.lastInfo.lastEventTime ||
                        data.lastInfo.lastOperationProgressId
                    )
                );

                if (
                    !this.isMultipleOrdersByResource &&
                    this.$router.currentRoute.name !== "operator-point-resource" &&
                    uniqueResources.length !== 1 &&
                    !hasAppointments &&
                    !selectedResourceId
                ) {
                    this.resource = {
                        appointmentType: 1,
                        value: null,
                        text: null
                    };
                } else {
                    const targetResourceId = selectedResourceId || this.$router.currentRoute.params.resource_id;
                    const res = data.resource?.find(f => f.id == targetResourceId) || uniqueResources.find(f => f.id == targetResourceId) || data.lastInfo?.lastResource || uniqueResources[0];
                    this.resource = {
                        appointmentType: res?.appointmentType ?? 1,
                        value: res?.id ?? (targetResourceId ? Number(targetResourceId) : null),
                        text: res?.name ?? null
                    };
                }

                this.multipleOperationsList = this.multiple.operations.map((order) => ({
                    name: `${order.orderNumber}/${order.operationNumber}`,
                    id: order.operationId
                }));

                const localOperations = data.operations.map((e) => ({
                    id: e.operationId,
                    name: e.operationName
                }));

                this.UPDATE_OPERATIONS_MODAL_OPERATIONS([...localOperations]);
                this.UPDATE_CURRENT_OPERATIONS_MODAL_OPERATIONS([...localOperations]);
                this.UPDATE_OPERATIONS_MODAL_FILTERED_OPERATIONS_LIST([...localOperations]);

                return Promise.resolve(response);
            } catch (error) {
                console.error(error);
                return Promise.reject(error);
            } finally {
                this.setCardsData();
                useLoading && this.removeRequestLoading();
            }
        },
        async getOrder(useLoading = true, is_rework = false) {
            const GET_ORDER_URL = `/api/mysfc/operator/operation/${this.$router.currentRoute.params.order_id}?isRework=${is_rework}&siteId=${this.currentSite}`;
            try {
                useLoading && this.UPDATE_FLAG_SHOW_OVERLAY(true);
                const response = await this.$http2.get(GET_ORDER_URL);
                const data = response.data.data;

                this.order = data;

                const uniqueResources = [];
                const seenIds = new Set();
                data.resources?.forEach(r => {
                    if (r && r.id && !seenIds.has(r.id)) {
                        seenIds.add(r.id);
                        uniqueResources.push(r);
                    }
                });

                const selectedResourceIdOrder = data.lastInfo?.lastResource?.id || this.resource?.value;
                const hasAppointmentsOrder = !!(
                    data.lastInfo &&
                    (
                        (data.lastInfo.lastStatusId && data.lastInfo.lastStatusId !== 1) ||
                        data.lastInfo.lastEventTime ||
                        data.lastInfo.lastOperationProgressId
                    )
                );

                if (this.$router.currentRoute.name !== "operator-point-resource" && !hasAppointmentsOrder && !selectedResourceIdOrder && uniqueResources.length !== 1) {
                    this.resource = {
                        appointmentType: 1,
                        value: null,
                        text: null
                    };
                } else {
                    const targetResourceId = selectedResourceIdOrder || this.$router.currentRoute.params.resource_id;
                    const res = data.lastInfo?.lastResource || data.resources?.find(f => f.id == targetResourceId) || uniqueResources[0];
                    this.resource = {
                        appointmentType: res?.appointmentType ?? 1,
                        value: res?.id ?? null,
                        text: res?.name ?? null
                    };
                }

                this.createListOfOrderNameAndOperation();

                this.producedQuantity = data?.producedQuantity
                    ? Number(data.producedQuantity)
                    : 0;
                this.plannedQuantity = data?.plannedQuantity ? Number(data.plannedQuantity) : 0;
                this.remainingQuantity = 0;

                const convertPercentage = (number) =>
                    `${(parseFloat(number) * 100).toFixed(0)}%`;

                this.percentProductive = convertPercentage(this.order.completedProgress);
                this.percentCompleted = convertPercentage(this.order.timeConsumed);
                this.progressoPrevisto = convertPercentage(this.order.theoricalProgress);
                this.progressoReal = convertPercentage(this.order.realProgress);

                this.defaultMaterial = {
                    value: data.productId,
                    text: data.product
                };
                this.defaultOrder = {
                    value: data.orderId,
                    text: data.orderNumber
                };

                const goodQuantity = data.producedQuantity - data.refuseQuantity - data.reworkQuantity;

                this.currentResource = {
                    ...this.currentResource,
                    prodPercent: (data.realProgress * 100).toFixed(0),
                    perfPercent: (Number(data.theoricalProgress || 0) * 100).toFixed(0),
                    totalQuantity: data.plannedQuantity,
                    producedQuantity: data.producedQuantity,
                    refuse: data.refuseQuantity,
                    goodQuantity: goodQuantity,
                    reworkQuantity: data.reworkQuantity,
                    quality: data.producedQuantity > 0 ? ((goodQuantity / data.producedQuantity) * 100).toFixed(1) : "0.0"
                };

                return Promise.resolve(response);
            } catch (error) {
                console.error(error);

                return Promise.reject(error);
            } finally {
                useLoading && this.removeRequestLoading();
            }
        },
        updateFieldsList(option) {
            if (option.title === "Material") {
                this.getOrderList(option.item.id);
            }

            if (option.title === "Order") {
                this.getMaterialList(option.item.id);
            }
        },
        async fetchResourceStats(orderId = null) {
            await this.$http2
                .get(
                    `/api/mysfc/operator/resource/${this.$router.currentRoute.params.resource_id}/appointment-resource?orderId=${orderId}`
                )
                .then((res) => {
                    this.currentResource = res.data.data;
                });
        },
        async getResourceInfo(order = null) {
            const orderId = order
                ? order.id
                : this.$router.currentRoute.params.order_id == 0
                    ? null
                    : this.$router.currentRoute.params.order_id;
            await this.fetchResourceStats(orderId);

            await this.getResourceOrder(false, false, order ? order.id : null);
            this.getMaterialList();
            this.getOrderList();
        },
        async getMaterialList(orderId = null) {
            await this.$http2
                .get(
                    `/api/mysfc/operator/material/selectable-for-resource?resourceId=${this.$router.currentRoute.params.resource_id}&siteId=${this.currentSite}&orderId=${orderId}`
                )
                .then((res) => {
                    this.materialList =
                        res.data.data?.map((e) => ({
                            ...e,
                            text: e.materialName,
                            value: e.materialId
                        })) ?? [];
                });
        },
        async getOrderList(materialId = null) {
            await this.$http2
                .get(
                    `/api/mysfc/operator/order/selectable-for-resource?resourceId=${this.$router.currentRoute.params.resource_id}&siteId=${this.currentSite}&materialId=${materialId}`
                )
                .then((res) => {
                    this.orderList =
                        res.data.data?.map((e) => ({
                            ...e,
                            name: `${e.orderNumber} / ${e.operationName}`,
                            text: `${e.orderNumber} / ${e.operationName}`,
                            value: e.orderId,
                            id: e.orderId
                        })) ?? [];
                });
        },
        async getResourceOrder(useLoading = true, isNew = false, orderIdAppointment = null, isRework = false) {
            const orderId = orderIdAppointment
                ? orderIdAppointment
                : this.$router.currentRoute.params.order_id == 0
                    ? null
                    : this.$router.currentRoute.params.order_id;
            const GET_ORDER_URL = `/api/mysfc/operator/operator-order?SiteId=${this.currentSite}&orderId=${isNew ? null : orderId}`;

            try {
                useLoading && this.UPDATE_FLAG_SHOW_OVERLAY(true);

                const response = await this.$http2.get(GET_ORDER_URL);

                let data = response.data.data;

                if (Array.isArray(data)) {
                    const resourceId = this.$router.currentRoute.params.resource_id;
                    const isFinished = (item) => {
                        const status = item.lastInfo?.lastStatus || item.lastByUser?.lastStatusByUser;
                        return status === "Completed" || status === "Operação Finalizada";
                    };
                    let foundData = data.find(
                        (item) => item.resources?.some((r) => r.id == resourceId) && !isFinished(item)
                    );
                    if (!foundData) {
                        foundData = data.find((item) => item.resources?.some((r) => r.id == resourceId));
                    }
                    data = foundData || data[0];
                }

                if (!data) {
                    console.warn("Order data not found for the given parameters.");
                    this.order = { lastInfo: {} }; // Initialize with safe defaults to prevent downstream errors
                    if (this.$toast) {
                        this.$toast.warning("Dados da ordem não encontrados.");
                    } else if (this.$bvToast) {
                        this.$bvToast.toast("Dados da ordem não encontrados.", {
                            title: "Aviso",
                            variant: "warning",
                            solid: true
                        });
                    }
                    return Promise.resolve(response); // Resolve gracefully or handle as specific error state
                }

                this.order = data;

                const uniqueResources = [];
                const seenIds = new Set();
                data.resources?.forEach(r => {
                    if (r && r.id && !seenIds.has(r.id)) {
                        seenIds.add(r.id);
                        uniqueResources.push(r);
                    }
                });

                const lastResource = this.isMultipleOrders ? this.multiple.lastInfo?.lastResource : data.lastInfo?.lastResource;
                if (this.isMultipleOrdersByResource) {
                    const targetResourceId = this.resource?.value || this.$router.currentRoute.params.resource_id;
                    const res = data.resources?.find(f => f.id == targetResourceId);
                    this.resource = {
                        appointmentType: res?.appointmentType ?? this.resource?.appointmentType ?? 1,
                        value: res?.id ?? (targetResourceId ? Number(targetResourceId) : null),
                        text: res?.name ?? this.resource?.text ?? null
                    };
                } else if (this.$router.currentRoute.name !== "operator-point-resource" && !lastResource && uniqueResources.length !== 1) {
                    this.resource = {
                        appointmentType: 1,
                        value: null,
                        text: null
                    };
                } else {
                    const res = lastResource || data.resources.find(f => f.id == this.$router.currentRoute.params.resource_id) || uniqueResources[0];
                    this.resource = {
                        appointmentType: res?.appointmentType ?? 1,
                        value: res?.id,
                        text: res?.name
                    };
                }

                this.defaultMaterial = {
                    value: data.productId,
                    text: data.product
                };
                this.defaultOrder = {
                    value: data.orderId,
                    text: data.orderNumber
                };

                this.allowChangeOrder = data.lastInfo?.lastStatusId === 1;
                this.allowChangeMaterial = data.lastInfo?.lastStatusId === 1;

                this.createListOfOrderNameAndOperation();

                this.producedQuantity = data?.producedQuantity
                    ? Number(data.producedQuantity)
                    : 0;
                this.plannedQuantity = data?.plannedQuantity ? Number(data.plannedQuantity) : 0;
                this.remainingQuantity = 0;

                const convertPercentage = (number) =>
                    `${(parseFloat(number) * 100).toFixed(0)}%`;

                this.percentProductive = convertPercentage(this.order.completedProgress);
                this.percentCompleted = convertPercentage(this.order.timeConsumed);
                this.progressoPrevisto = convertPercentage(this.order.theoricalProgress);
                this.progressoReal = convertPercentage(this.order.realProgress);

                const goodQuantity = data.producedQuantity - data.refuseQuantity - data.reworkQuantity;

                this.currentResource = {
                    ...this.currentResource,
                    prodPercent: (data.realProgress * 100).toFixed(0),
                    perfPercent: (Number(data.theoricalProgress || 0) * 100).toFixed(0),
                    totalQuantity: data.plannedQuantity,
                    producedQuantity: data.producedQuantity,
                    refuse: data.refuseQuantity,
                    goodQuantity: goodQuantity,
                    reworkQuantity: data.reworkQuantity,
                    quality: data.producedQuantity > 0 ? ((goodQuantity / data.producedQuantity) * 100).toFixed(1) : "0.0"
                };

                return Promise.resolve(response);
            } catch (error) {
                console.error(error);

                return Promise.reject(error);
            } finally {
                useLoading && this.removeRequestLoading();
            }
        },
        createListOfOrderNameAndOperation() {
            const { order, isMultipleOrders, multiple } = this;
            if (isMultipleOrders) {
                const list = multiple.operations.map(
                    ({ id, orderNumber, operationNumber }) => ({
                        preactorOrderId: id,
                        orderLabel: `${orderNumber}/${operationNumber}`
                    })
                );

                this.listOfOrderNameAndOperation = [...list];
                return list;
            }

            const { id, orderNumber, operationNumber } = order;

            const list = [
                {
                    id: id,
                    name: orderNumber && operationNumber ? `${orderNumber}/${operationNumber}` : ""
                }
            ];

            this.listOfOrderNameAndOperation = [...list];
        },
        showToast(title, icon, text, variant) {
            const resourceLimitMessage = "resource exceeded the allowed limit of simultaneous orders ";
            if (text?.startsWith(resourceLimitMessage)) {
                title = this.$t("ResourceStatus.Attention");
                text = text.slice(resourceLimitMessage.length);
                variant = "alert";
                icon = "AlertOutline";
            }
            this.$toast({
                component: ToastificationContent,
                props: {
                    title,
                    icon,
                    text,
                    variant
                }
            });
        },
        showSwal(title, icon, text) {
            return this.$swal({
                title,
                text,
                icon,
                showCancelButton: true,
                confirmButtonText: "Yes!",
                customClass: {
                    confirmButton: "btn btn-primary",
                    cancelButton: "btn btn-outline-danger ml-1"
                },
                buttonsStyling: false
            });
        },
        async loadPage(is_rework, order = null) {
            const isMultipleOrders =
                this.$router.currentRoute.params.multiple?.toString() === "true";

            this.isMultipleOrders = isMultipleOrders;
            this.UPDATE_FLAGS_IS_MULTIPLE_ORDERS(isMultipleOrders);

            this.infoOperacao = this.$router.currentRoute.params.multiple != "true";

            this.selectedOrders = this.isMultipleOrders
                ? this.$router.currentRoute.params.orders
                : [];

            this.preactorsOrdersId = this.$router.currentRoute.params.preactor_orders;

            this.UPDATE_FLAG_SHOW_OVERLAY(true);
            try {
                if (this.$router.currentRoute.name !== "operator-point-resource") {
                    await (this.isMultipleOrders
                        ? this.getOrders(false, is_rework)
                        : this.getOrder(false, is_rework));

                } else {
                    await this.getResourceInfo(order);

                    if (this.$router.currentRoute.params.order_id == 0 && this.order?.id) {
                        this.$router.replace({
                            params: {
                                ...this.$route.params,
                                order_id: this.order.orderId
                            },
                            query: this.$route.query
                        });
                    }
                }
                await this.getResourcesList(false);
                await this.getContext(false);
                this.setCardsData();
                // await this.fetchOEEData();
                await this.checkRNCChecklist();
            } catch {
                if (this.$router.currentRoute.name !== "operator-point-resource") {
                    this.$router.push({
                        name: "operator-orders-all",
                        params: { prefix: localStorage.getItem("prefix") }
                    });
                }
            } finally {
                this.UPDATE_FLAG_SHOW_OVERLAY(false);
                this.checkAutoReload();
            }
        },
        handleLanguageChange() {
            this.setCardsTimestamps(this.lastActivities);
        },
        async fetchOEEData() {
            try {
                const resourceId = this.resource?.value;
                if (!resourceId) return;

                const response = await this.$http2.get(
                    `/api/oee/calculate?ResourcesIds=${resourceId}&SiteId=${this.currentSite}`
                );
                const data = response.data.data;
                const resourceOEE = data.oeeByResource.find(
                    (r) => r.resourceId == resourceId
                );

                if (resourceOEE) {
                    this.currentResource = {
                        ...this.currentResource,
                        perfPercent: resourceOEE.performanceComponent.toFixed(0),
                        quality: resourceOEE.qualityComponent.toFixed(1)
                    };
                }
            } catch (error) {
                console.error("Error fetching OEE data:", error);
            }
        },
        async checkRNCChecklist() {
            try {
                const operationId = this.isMultipleOrders
                    ? this.multiple?.operations?.[0]?.operationId
                    : this.order?.id;
                const resourceId = this.resource?.value;

                if (!operationId || !resourceId) return;

                const response = await http3.get(`api/myquality/opened-checklist/operation`, {
                    params: {
                        operationId,
                        resourceId
                    }
                });

                const data = response.data.data;
                this.hasRNC = data.hasRNC ?? false;
                this.rncChecklistData = data.checklist;
                this.checklistTriggerType = data.triggerType;
                this.checklistTriggerTarget = data.triggerTarget;
                this.shouldShowChecklist = data.showChecklist ?? false;
            } catch (error) {
                console.error("Error checking for RNC checklist:", error);
            }
        },
        async checkChecklistAfterAppointment() {
            try {
                const operationId = this.isMultipleOrders
                    ? this.multiple?.operations?.[0]?.operationId
                    : this.order?.id;
                const resourceId = this.resource?.value;

                if (!operationId || !resourceId) return false;

                const response = await http3.get(`api/myquality/opened-checklist/operation`, {
                    params: {
                        operationId,
                        resourceId
                    }
                });

                const data = response.data.data;

                if (data.showChecklist && data.checklist && !data.hasRNC) {
                    this.rncChecklistData = data.checklist;
                    this.checklistTriggerType = data.triggerType;
                    this.checklistTriggerTarget = data.triggerTarget;
                    this.shouldShowChecklist = true;
                    return true;
                }

                return false;
            } catch (error) {
                console.error("Error checking checklist after appointment:", error);
                return false;
            }
        },
        handleOpenRNCChecklist() {
            this.showRNCChecklistForm = true;
        },
        async handleRNCChecklistSubmit(checklistFields) {
            this.rncChecklistSubmissionError = false;
            try {
                const operationProgressId = this.order?.lastInfo?.lastOperationProgressId;

                const body = {
                    checklistId: this.rncChecklistData?.id,
                    operationProgressId: operationProgressId,
                    isPriority: false,
                    triggerType: this.checklistTriggerType,
                    triggerTarget: this.checklistTriggerTarget,
                    fields: checklistFields.map(field => ({
                        value: String(field.value ?? ""),
                        fieldId: field.id
                    }))
                };

                const response = await http3.post(`api/myquality/checklistValues`, body);
                const checklistValuesId = response?.data?.data?.checklistValuesId;

                if (checklistValuesId) {
                    this.currentRNCChecklistValuesId = checklistValuesId;
                }

                this.showToast(
                    this.$t('Sucesso'),
                    'CheckIcon',
                    this.$t('Checklist enviado com sucesso'),
                    'success'
                );

                if (!this.rncChecklistData?.hasValidation) {
                    this.showRNCChecklistForm = false;
                    this.currentRNCChecklistValuesId = null;
                    this.rncChecklistSubmissionError = false;
                }
            } catch (error) {
                console.error("Error submitting RNC checklist:", error);
                this.rncChecklistSubmissionError = true;
                this.showToast(
                    this.$t('Erro'),
                    'AlertTriangleIcon',
                    this.$t('Erro ao enviar checklist'),
                    'danger'
                );
            }
        },
        handleRNCChecklistClose() {
            this.showRNCChecklistForm = false;
            this.currentRNCChecklistValuesId = null;
            this.rncChecklistSubmissionError = false;
        },
        async handleChecklistCompleted() {
            this.shouldShowChecklist = false;
            this.rncChecklistData = null;
            this.checklistTriggerType = null;
            this.checklistTriggerTarget = null;

            const modal = this.modal.type.toLowerCase();
            const is_rework = this.appointmentType;
            await this.loadPage(modal == "finish" ? false : is_rework);
            this.closeAppointmentModal();
        },
        checkAutoReload() {
            if (this.resource && this.resource.appointmentType === 2) {
                if (!this.autoReloadInterval) {
                    this.autoReloadInterval = setInterval(() => {
                        this.silentReload();
                    }, 10000);
                }
            } else {
                if (this.autoReloadInterval) {
                    clearInterval(this.autoReloadInterval);
                    this.autoReloadInterval = null;
                }
            }
        },
        async silentReload() {
            try {
                if (this.$router.currentRoute.name !== "operator-point-resource") {
                    await (this.isMultipleOrders
                        ? this.getOrders(false, this.appointmentType)
                        : this.getOrder(false, this.appointmentType));
                } else {
                    await this.getResourceInfo();
                }
                this.setCardsData();
            } catch (error) {
                console.error("Erro ao recarregar a tela silenciosamente:", error);
            }
        }
    },
    data() {
        return {
            orderModalShowLinks: false,
            orderListModalMode: "details",
            usersList: [],
            multipleOperationsList: [],
            multiple: {
                orders: [],
                status: {
                    name: "",
                    color: ""
                }
            },
            idsNotFound: [],
            listOfOrderNameAndOperation: [],
            resource: {
                appointmentType: 1,
                value: null,
                text: null
            },
            defaultMaterial: {
                value: null,
                text: null
            },
            defaultOrder: {
                value: null,
                text: null
            },
            producedQuantity: 0,
            plannedQuantity: 0,
            remainingQuantity: 0,
            defaultDate: {
                setup: "",
                start: ""
            },
            statusObject: {},
            timer: {
                card: "",
                data: {
                    hour: "00",
                    minute: "00",
                    second: "00"
                },
                interval: null,
                startingTime: 1686669022126
            },
            resourcesList: [],
            isMultipleOrders: false,
            resource: null,
            allowChangeResource: false,
            allowChangeDate: false,
            allowChangeMaterial: false,
            allowChangeOrder: false,

            percentProductive: null,
            percentCompleted: null,
            progressoPrevisto: null,
            progressoReal: null,

            infoOperacao: null,
            selectedOrders: null,
            preactorsOrdersId: null,

            attributesFields: null,

            refuseStatus: [],
            customFields: [],
            statusList: [],
            shiftList: [],
            peopleList: [],

            user_id: JSON.parse(localStorage.getItem("userData")).guid,

            currentSite: this.$cookies.get("userInfo").currentSite,
            prefix: localStorage.getItem("prefix") || this.$router.currentRoute.params.prefix,

            modal: {
                opened: false,
                typeId: null,
                type: ""
            },
            order: {
                last_status_by_user: "",
                last_color_status_by_user: "",
                order_no: "",
                op_no: "",
                lastInfo: {
                    lastStatusId: 1
                }
            },
            cards: {
                setup: {
                    show: true,
                    active: false
                },
                startPartial: {
                    show: true,
                    active: false
                },
                stop: {
                    show: true,
                    active: false
                },
                finish: {
                    show: true,
                    active: false
                }
            },
            showModalOrder: false,
            showOverflowProductionProgress: true,
            showModalOrderDetailsList: false,
            currentResource: {},
            materialList: [],
            orderList: [],
            hasRNC: false,
            rncChecklistData: null,
            showRNCChecklistForm: false,
            currentRNCChecklistValuesId: null,
            rncChecklistSubmissionError: false,
            checklistTriggerType: null,
            checklistTriggerTarget: null,
            shouldShowChecklist: false,
            autoReloadInterval: null,
            showManHourModal: false,
            showMultipleRefusesModal: false,
            multipleRefuses: [],
            manHourHistory: []
        };
    },
    beforeDestroy() {
        if (this.autoReloadInterval) {
            clearInterval(this.autoReloadInterval);
        }
        this.RESET_STATES();
    },
    async created() {
        if (this.$router.currentRoute.name === "operator-point-resource") {
            this.$router.replace({
                name: "operator-point-resource",
                params: {
                    ...this.$route.params,
                    current_order: 1
                },
                query: this.$route.query
            });
        }
        await this.loadPage(this.appointmentType);
    },
    mounted() {
        this.$watch("$i18n.locale", function () {
            this.handleLanguageChange();
        });
    }
};
</script>

<style lang="scss">
body:has(.hide-scroll) {
    overflow: hidden !important;
}

.app-content-operator:has(#production-progress) {
    padding: 0 !important;
}

body:has(#production-progress) footer.footer {
    display: none !important;
}

.finish-quantity-swal .swal2-deny {
    order: 0;
    margin-right: auto !important;
    font-weight: 600;
    font-size: 17px;
    line-height: 20px;
    color: #974900 !important;
    border-radius: 5px;
    border-color: transparent !important;

    &:hover {
        background-color: #ffede1 !important;
    }
}
</style>

<style lang="scss" scoped>
#production-progress {
    // Adaptando ao container app-content
    width: 100%;
    min-height: 84vh;

    display: flex;
    flex: 1;
    flex-direction: column;
    justify-content: flex-start;
    align-items: center;

    .content-container {
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        min-height: 96vh;
        height: auto;
        width: inherit;
        padding: 24px 24px 12px;

        &:has(.point-resource-infos) {
            padding-top: 24px;
            padding-bottom: 8px;
        }

        .point-resource-infos {
            display: flex;
            align-items: center;
            flex-shrink: 0;
            border-radius: 24px;
            border: 1px solid #cfc4be;
            background: #fafafa;
            box-shadow: 0px 8px 30px 0px rgba(58, 46, 38, 0.1);
            margin-top: 24px;
            margin-bottom: 16px;

            .order-block,
            .material-block {
                display: flex;
                flex-direction: column;
                align-items: center;
                justify-content: center;
                border-right: 1px solid #cfc4be;
                width: 100%;
                padding: 16px 20px;
                min-height: 0;

                &.--remove-border-right {
                    border-right: none;
                }

                .label {
                    color: #998f8a;
                    font-size: 16px;
                    font-weight: 600;
                    line-height: 26px;
                    /* 162.5% */
                }

                .value {
                    color: #4c4541;
                    font-size: 16px;
                    font-weight: 600;
                    line-height: 26px;
                    /* 162.5% */
                }
            }

            .material-block .value {
                word-break: break-word;
                max-height: 5.5rem;
                overflow-y: auto;
                -webkit-overflow-scrolling: touch;
            }

            .add-resource {
                max-width: 70px;
                width: 100%;
                height: 100px;
                display: flex;
                align-items: center;
                justify-content: center;
                cursor: pointer;
                border-top-right-radius: 24px;
                border-bottom-right-radius: 24px;

                svg {
                    width: 22px;
                    height: 22px;
                }

                &:hover {
                    background: #ffede2;
                }

                &:active {
                    background: #ffdbc4;
                }
            }
        }

        .info-banner-wrapper {
            margin-bottom: 12px;
            width: 100%;
            display: flex;
            flex-direction: column;
        }

        .activity-cards {
            display: grid;
            grid-template-columns: repeat(auto-fit, minmax(240px, 1fr));
            grid-auto-rows: 1fr;
            flex: 1;
            gap: 20px;
            margin-bottom: 12px;
            min-height: 0;
            align-content: start;
            align-items: stretch;
            box-sizing: border-box;

            >.activity-card {
                flex: 1 1 0;
                min-height: 0;
                min-width: 0;
                align-self: stretch;
            }
        }
    }
}

#pdp__button-c {
    margin-top: auto;
    flex-shrink: 0;
    display: flex;
    gap: 30px;

    .tools-button-desktop {
        display: flex;
    }

    .buttons-mobile {
        display: none;
    }

    .orders-details-button-desktop {
        display: flex;
    }
}

@media (max-width: 1400px) {
    #production-progress {
        .content-container {
            padding-top: 106px;
        }
    }
}

@media (max-width: 1100px) {
    #production-progress {
        .content-container {
            padding-bottom: 150px !important;

            #pdp__button-c {
                .tools-button-desktop {
                    display: none;
                }

                .buttons-mobile {
                    display: flex;
                }

                .orders-details-button-desktop {
                    display: none;
                }

                .rnc-checklist-btn {
                    svg {
                        fill: #ffffff !important;

                        path {
                            fill: #ffffff !important;
                        }
                    }
                }

                width: 100%;
                padding: 16px;
                position: fixed;
                left: 0;
                bottom: 0;
                z-index: 99;
                background-color: #fafafa;
            }
        }
    }
}

@media (min-width: 576px) and (max-width: 1024px) {
    #production-progress {
        min-height: 0;

        .content-container {
            min-height: 0;
            height: calc(100dvh - 158px);
            padding: 12px 24px 86px !important;
            justify-content: flex-start;
            overflow: hidden;
        }

        .activity-cards {
            grid-template-columns: repeat(2, minmax(0, 1fr));
            grid-template-rows: repeat(2, minmax(0, 1fr));
            grid-auto-rows: minmax(0, 1fr);
            flex: 1 1 auto;
            min-height: 0;
            gap: 12px;
            margin-bottom: 0;

            >.activity-card {
                min-height: 0;
            }
        }
    }
}

@media (min-width: 576px) and (max-width: 768px) {
    #production-progress {
        .production-progress__page-header.remove-fixed {
            margin-top: 86px;

            &.point-resource-header {
                margin-top: 49px;
            }
        }
    }
}

@media (max-width: 575px) {
    #production-progress {
        .activity-cards {
            grid-template-columns: 1fr;
        }
    }
}

@media (max-width: 768px) and (min-width: 714px) {
    #production-progress {
        .content-container {
            height: auto;
            padding-top: 24px;

            &:has(.point-resource-infos) {
                padding-top: 24px;
            }
        }
    }
}

@media (max-width: 714px) and (min-width: 480px) {
    #production-progress {
        .content-container {
            height: auto;
            padding-top: 24px;

            &:has(.point-resource-infos) {
                padding-top: 24px;
            }
        }
    }
}

@media (max-width: 550px) {
    #production-progress {
        .content-container {
            &:has(.point-resource-infos) {
                padding-top: 24px !important;
            }

            .point-resource-infos {
                flex-direction: column;

                .order-block,
                .material-block {
                    border-right: none;
                    border-bottom: 1px solid #cfc4be;
                    padding: 12px 24px;

                    .label {
                        font-size: 12px;
                        line-height: 16px;
                        /* 133.333% */
                    }

                    .value {
                        font-size: 14px;
                        line-height: 20px;
                        /* 142.857% */
                    }
                }

                .add-resource {
                    max-width: 100%;
                    height: 38px;
                    border-top-right-radius: 0;
                    border-bottom-left-radius: 24px;
                    border-bottom-right-radius: 24px;

                    svg {
                        width: 18px;
                        height: 18px;
                    }
                }
            }
        }
    }
}

@media (max-width: 550px) {
    .content-container {
        padding-top: 24px !important;
        padding-bottom: 150px !important;
        height: auto !important;
    }
}

@media (min-width: 576px) and (max-width: 1024px) {
    #production-progress .content-container {
        height: calc(100dvh - 158px);
    }
}

@media (min-width: 1025px) {
    #production-progress {
        .production-progress__page-header.remove-fixed+.content-container {
            padding-top: 24px;
            min-height: calc(100dvh - 140px);
        }

        .content-container {
            min-height: calc(100dvh - 49px);
        }

        .activity-cards {
            grid-template-columns: repeat(auto-fit, minmax(220px, 1fr));
        }
    }
}

.rnc-checklist-container {
    position: fixed;
    top: 0;
    left: 0;
    width: 100vw;
    height: 100dvh;
    background: #fcfcfc;
    z-index: 9999;
    overflow: auto;
}
</style>
